import { query_ding_form_component_list } from 'liyu-pc-base/api/oa_integration-model';

export default () => {
  const search_config: any = {
    model: {
      is_active: true,
      pageSize: 100000,
      column_fields: ['name', 'id'],
      request_source: 'strict',
    },
    watch: [],
  };
  return {
    getData: query_ding_form_component_list,
    searchConfig: search_config,
  };
};
